export class Destination {
    
    // TODO: int, not number
    id: number;
    alias: string;
    address: string;
    postalCode: string;
    city: string;
    latitude: string;
    longitude: string;
    deleted: boolean;
    isHome: boolean;
    priceArea: number;
    movitInstanceId: number;
    movitInstanceName: string;
    priceCategoryIds: number[];
    favoritePlacesListType: string = null;
    organizationId?: string = '';

    constructor(options) {
        this.id = options ? options.id : 0;
        this.alias = options ? options.alias : null;
        this.city = options ? options.city : null;
        this.address = options ? options.address : null;
        this.postalCode = options ? options.postalCode : null;
        this.latitude = options ? options.latitude : null;
        this.longitude = options ? options.longitude : null;
        this.deleted = options ? options.deleted : false; 
        this.isHome = options ? options.isHome : false;
        this.priceArea = options ? options.priceArea : 0,
        this.movitInstanceId = options ? options.movitInstanceId : "";
        this.movitInstanceName = options ? options.movitInstanceName : "";
        this.priceCategoryIds = options ? options.priceCategoryIds : [];
        this.favoritePlacesListType = options && options.favoritePlacesListType ? options.favoritePlacesListType : null;
        this.organizationId = options && options.organizationId ? options.organizationId : null;
    }

    get aliasAndMovitInstanceName(){
        return this.alias + ' (' + this.movitInstanceName + ')';
    }

    get hasPriceCategories(){
        return this.priceCategoryIds && this.priceCategoryIds.length > 0 && this.priceCategoryIds[0] > 0;
    }

    get bookingEnabled(){
        return this.hasPriceCategories;
    }

}

export default Destination;
